import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PostcodeLookupService {

  clickedFindAddressEmit: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }
}
